const trans_en_GB = {
  // Form Fields
  name: "Name",
  first_name: "First Name",
  last_name: "Last Name",
  name_ar: "Name in Arabic",
  name_en: "Name in English",
  price: "Price",
  email: "E-mail",
  password: "Password",
  confirm_password: "Confirm Password",
  phone_number: "Phone Number",
  business_name: "Business Name",
  business_type: "Business Type",
  shop_address: "Shop Address",
  cr_number: "CR Number",
  vat_number: "VAT Number",
  business_logo: "Business Logo",
  image: "Image",
  is_taxable: "Is Taxable",
  is_refunded: "Is Refunded",
  is_QRproduct: "Is QR Product",
  is_stockable: "Is Stockable",
  reset: "Reset",
  cart: "Cart",
  address: "Address",
  company: "Company",
  code: "Code",
  branch: "Branch",
  active: "Active",
  inactive: "Inactive",
  no_of_employees: "# of Employees",
  no_of_licenses: "# of Licenses",
  vat_certificate: "VAT Certificate",
  cr_certificate: "CR Certificate",
  change: "Change",
  preview: "Preview",

  // Form Validations
  validate_email_required: "The email field is required.",
  validate_email_invalid: "The input is not a valid E-mail!",
  validate_password_required: "The password field is required.",
  validate_password_min_characters: "Password must be of minimum 6 characters.",
  validate_password_confirm_not_matched: "Confirm password does not matched.",
  validate_first_name_required: "The first name field is required.",
  validate_first_name_min_characters:
    "First name must be of minimum 3 characters.",
  validate_last_name_required: "The last name field is required.",
  validate_last_name_min_characters:
    "Last name must be of minimum 3 characters.",
  validate_phone_required: "The phone number field is required.",
  validate_phone_exact_limit: "Phone must be of exactly 12 digits.",
  validate_image_file_type: "You can only upload JPG/PNG file!",
  validate_image_size_2: "Image must be smaller than 2MB!",
  validate_file_size_5: "file must be smaller than 5MB!",

  // Login
  dont_have_account: "Don't have an account?",
  login: "Login",
  visit_website: "Visit website",

  // Register
  already_have_an_account: "Already have an account?",
  sign_up: "Sign up",

  // Forgot
  forgot_password: "Forgot Password",
  send_otp: "Send OTP",
  verify_otp: "Verify OTP",
  reset_password: "Reset password",
  reset_password_successfully: "Your password reset Successfully!",

  // otp form
  opt_message:
    "A message with the OTP code has been sent on your mobile number. Kindly fill in the below field and Validate.",
  if_you_want_to_change_phone_number: "If you want to change phone number",
  click_here: "Click Here.",
  resend_code: "Resend Code",
  enable_in: "Enable in",
  validate: "Validate",

  // Menus
  home: "Home",
  companies: "Companies",
  help_desk: "Help Desk",
  profile: "Profile",
  commission: "Commission",
  payout_detail: "Payout Detail",

  // Table Columns
  action: "Action",
  type: "Type",
  status: "Status",
  date: "Date",
  description: "Description",
  attachment: "Attachment",
  customer_name: "Customer Name",
  contact: "Contact",
  assigned_to: "Assigned To",

  // Warnings
  warning_delete: "Are you sure to delete this entity?",

  // Miscellaneous
  yes: "Yes",
  no: "No",
  logout: "Logout",
  submit: "Submit",
  search: "Search",
  upload: "Upload",
  something_went_wrong: "Something went wrong",
  reference_no: "Reference No.",
  total_amount: "Total Amount",
  rejected: "Rejected",
  individual: "Individual",
  photo_of_id: "Photo of ID",
  validate_photo_of_id_required: "Photo of ID is required",
  company_name: "Company Name",
  validate_type_required: "The Type field is required.",
  validate_company_name_required: "The Company name field is required.",
  company_registration_document: "Company Registration Document",
  validate_company_registration_document_required:
    "The Company registration document field is required.",
  wallet_detail: "Wallet Detail",
  bank_detail: "Bank Detail",
  payout_history: "Payout History",
  available_balance: "Available Balance",
  level_config: "Level Configuration",
  account_title: "Account Title",
  bank_name: "Bank Name",
  account_number: "Account Number",
  branch_code: "Branch Code",
  city: "City",
  country: "Country",
  reseller_number: "Reseller Number",
  target: "Target",
  retain_rate: "Retain Rate",
  total: "Total",
  balance_details: "Balance Details",
  reference_number: "Reference Number",
  add_company: "Add Company",
  portal_url_not_configured: "The portal URL is not configured.",
  forward_to_csr: "Forward to CSR",
  mark_new: "Mark as New",
  mark_inprogress: "Mark as in Progress",
  mark_done: "Mark as Done",
  mark_closed: "Mark as Closed",
  amount: "Amount",
  kyc: "KYC",
  in_review: "In Review",
  new_tickets: "New Tickets",
  inprogress_tickets: "Tickets In Progress",
  done_tickets: "Tickets Done",
  closed_tickets: "Tickets Closed",
  late_tickets: "Late Tickets",
  delayed_tickets: "Delayed Tickets",
  ticket_updated: "Ticket Updated",
  ticket_updated_successfully: "The ticket has been updated successfully!",
  status_updated_successfully: "Status updated Successfully!",
  hi: "Hi",
  thankyou_for_applying_account: "Thank you for applying for an account!",
  account_pending_message:
    "Your account is currently pending approval by the site administrator.",
  account_rejection: "Unfortunately your account has been rejected!",
  account_under_review: "Your account is under review!",
  account_under_review_details:
    "It usually takes us around a day. Until the review is completed, You won't able to do anything",
  account_blocked: "Your account is blocked!",
  kindly_contact_at: "Kindly contact us at contact@anypos.ai",
  basic_level: "Basic Level",
  pro_level: "Pro Level",

  partner_rank: "Partner Rank",
  unpaid_comission: "Unpaid Comission",
  paid_comission: "Paid Comission",
  active_customers: "Active Customers",
  inactive_customers: "Inactive Customers",
  monthly_new_customers: "Monthly New Customers",
  monthly_inactive_customers: "Monthly Inactive Customers",
  submitting_kyc: "Submitting KYC",
  idle_customers: "Idle Customers",
  owner: "Owner",
  csr: "CSR",
};

export default trans_en_GB;
